import { ButtonHTMLAttributes, AnchorHTMLAttributes, ReactNode } from 'react';
import './Button.css';

type Variant = 'primary' | 'secondary' | 'ghost';
type Size = 'md' | 'lg';

type CommonProps = {
  variant?: Variant;
  size?: Size;
  children: ReactNode;
};

type ButtonProps = CommonProps & ButtonHTMLAttributes<HTMLButtonElement> & { as?: 'button' };
type AnchorProps = CommonProps & AnchorHTMLAttributes<HTMLAnchorElement> & { as: 'a' };

export function Button(props: ButtonProps | AnchorProps) {
  if (props.as === 'a') {
    const { as, variant = 'primary', size = 'md', children, className, ...rest } = props;
    return (
      <a {...rest} className={`btn btn--${variant} btn--${size} ${className ?? ''}`.trim()}>
        {children}
      </a>
    );
  }

  const { as, variant = 'primary', size = 'md', children, className, ...rest } = props;
  return (
    <button {...rest} className={`btn btn--${variant} btn--${size} ${className ?? ''}`.trim()}>
      {children}
    </button>
  );
}
